import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full bg-ivory font-sans text-ink" data-id="element-0" data-mp="28u5uwe1s0p8m">
      <UrgencyBar data-id="element-1" data-mp="28sl5t3y8dyi5" />
      <Hero data-id="element-2" data-mp="28s30zixi6bym" />
      <main data-id="element-3" data-mp="23vkvggucm9l8">
        <TestimonialsSection data-id="element-4" data-mp="23vul23bheeqe" />
        <ProblemSection data-id="element-5" data-mp="23utcc5hxu4bu" />
        <SolutionSection data-id="element-6" data-mp="23t8h0dnsuhcx" />
        <VolumesSection data-id="element-7" data-mp="3ik7eyd5x05p2" />
        <BonusesSection data-id="element-8" data-mp="3iiweam7rne26" />
        <OfferSection data-id="element-9" data-mp="3ijftvw9y1qd1" />
        <GuaranteeSection data-id="element-10" data-mp="3ii4ro0w5cqo1" />
        <FaqSection data-id="element-11" data-mp="3ml13n8r6loj0" />
        <FinalCtaSection data-id="element-12" data-mp="3mkho1yp07c85" />
      </main>
      <Footer data-id="element-13" data-mp="3mjg93j4va5l5" />
      <StickyCta data-id="element-14" data-mp="3rc9e8848zfxr" />
    </div>;
}